import { isEventbriteTLD } from '../selectors/app';
import { isSplitTreatmentEnabled } from '../selectors/splitio';
import { CheckoutState } from '../state';
import { ENABLE_APPLE_PAY, ENABLE_INTERSTITIAL_STEP } from '../utils/splitio';

const QA_ENV_URLS_REGEX = /^(https?:\/\/)?(www.)?(evbqa(\d)*).com$/;

const isQAEnv = (host: string) => QA_ENV_URLS_REGEX.test(host);

export const isEventbriteTLDInQAEnv = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const parent = urlParams.get('parent') || '';
    return isQAEnv(window.location?.host) && isQAEnv(parent);
};

export const isStatsigFreeTrialEnabled = (state: CheckoutState): boolean =>
    (isEventbriteTLD(state) || isEventbriteTLDInQAEnv()) &&
    isSplitTreatmentEnabled(state, ENABLE_INTERSTITIAL_STEP);

export const isApplePayExperimentationEnabled = (state: CheckoutState) =>
    (isEventbriteTLD(state) || isEventbriteTLDInQAEnv()) &&
    isSplitTreatmentEnabled(state, ENABLE_APPLE_PAY);
